<template>
	<aside id="advanced">
		<div class="map mb-4">
			<google-maps ref="gMaps" :searchString="searchString"/>
		</div>
		<p class="header">Browse Locations Near You</p>
		<div class="results">
			<div class="content">
				<provider v-for="(item, index) in allSearchResults" 
                  :key="index" 
                  :data="item"/>
			</div>
		</div>
		<div class="loadMore my-4" v-if="!searchResults.isLastPage">
			<button @click="loadMore()" class="btn-beltone">
				<div v-show="loading" class="btn-spinner white">
					<div class="outer"><div class="inner"><span></span></div></div>
				</div>
				<span :class="{'hidden': loading}">Load More</span>
			</button>
		</div>
	</aside>
</template>

<script>
import { mapState, mapActions, mapMutations } from 'vuex';
import Services from '../../mixins/services';
import Provider from './provider'
import googleMaps from './map'

export default {
	mixins: [Services],
	props: ['searchString', 'searchRadius', 'usingSearchString', 'dealerId'],
	components: {
		Provider,
		googleMaps
	},
	data: function () {
		return {
			loading: false,
		}
	},
	computed: mapState({
		geoLocation: state => state.LocationSearch.geoLocation,
		clientToken: state => state.ClientToken.clientToken,
		endOfResults: state => state.LocationSearch.endOfResults,
		searchResults: state => state.LocationSearch.searchResults,
		allSearchResults: state => state.LocationSearch.allSearchResults,
	}),
	methods: {
		...mapActions('LocationSearch', { getSearchResults: 'getSearchResults' }),
		loadMore() {
			this.loading = true;
			let isNum = /^\d+$/.test(this.searchString);
			this.getSearchResults({
				Longitude: !this.usingSearchString ? this.geoLocation.longitude : null,
				Latitude: !this.usingSearchString ? this.geoLocation.latitude : null,
        SearchRadius: this.searchRadius,
        ZipCode: this.usingSearchString ? (isNum ? this.searchString : null) : null,
        City: this.usingSearchString ? (isNum ? null : this.searchString) : null,
				PageSize: 8,
				PageNumber: this.searchResults.pageNumber + 1,
        dealerId: this.dealerId,
				clientToken: this.clientToken,
				cb: () => {
					this.loading = false;
				}
			})
		}
	},
	mounted() {

	},
	created() {
	}
}
</script>